<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12 sm4 offset-sm4>
   			<v-card>
	   			<v-card-title>
            <v-spacer></v-spacer>
            <v-dialog v-model="dialog" max-width="400px" v-if="hasCreateAccess">
              <v-btn slot="activator" round color="primary" dark small class="ml-4">New Role</v-btn>
              <v-form v-model="validForm">
                <v-card>
                  <v-card-title>
                    <span class="headline" v-text="item.id ? 'Update Role' : 'Add Role'"></span>
                  </v-card-title>

                  <v-card-text>
                    <v-container grid-list-md py-0>
                      <v-layout wrap>
                        <v-flex xs12>
                          <v-text-field :rules="rules" counter="50" v-model="item.role" label="Role"></v-text-field>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" flat :disabled="processing" @click.native="close">Cancel</v-btn>
                    <v-btn color="blue darken-1" flat :disabled="!validForm || processing" :loading="processing" @click.native="item.id ? updateItem() : addItem()" v-text="item.id ? 'Update' : 'Save'"></v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="roles"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
				      <td>{{ props.item.role }}</td>
              <td class="align-center justify-center layout px-0">
                <edit-btn v-if="props.item.is_editable" :item="props.item" />
                <delete-btn v-if="props.item.is_editable" :item="props.item" />
              </td>
				    </template>
				    <template slot="no-data" v-if="!processing && !roles.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <action-dialog action="delete" :status="deleteDialog" @close="closeDeleteDialog" @success="deleteItem(roles)" />

			</v-card>
   		</v-flex>
   	</v-layout>
    
  </v-flex>
</template>

<script>

  export default {
    name: 'Roles',
    data () {
      return {
        model: 'role',
      	title: "Roles",
        validForm: false,
      	processing: false,
        dialog: false,
        deleteDialog: false,
      	roles: [],
        headers: [
          { text: 'Role', value: 'role'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        item: {},
        defaultItem: {
          id: "",
          role: "",
          is_editable: true,
          is_deleted: false
        },
        deletingItem: null,
        rules: [
          v => !!v || 'Role name is required',
          v => v && v.length >= 3 || 'Must be more than 2 characters',
          v => v && v.length <= 50 || 'Maximum 50 characters allowed'
        ]
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'User Roles',
	          disabled: true
	        },
	        {
	          text: 'View',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage User Roles')
    },
    methods: {

      getRoles () {
        this.processing = true
        this.axios.get(this.config.apis.viewUserRoles)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.roles = response.data.data
            }
            else{
            	this.roles = []
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },
      addItem () {
        this.processing = true
        this.axios.post(this.config.apis.addUserRole, this.item)
          .then((response) => {
            
            if (this.isSuccessResponse(response)) {
              
              let new_item = Object.assign({}, this.item)
              new_item.id = response.data.data.id

              this.roles.unshift(new_item)

              this.notifySuccess('insertSuccess')
              this.close()
            }
            else{
              this.notifyError('insertError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },
      updateItem () {
      	this.processing = true
        this.axios.put(this.config.apis.updateUserRole.replace(":id", this.item.id), this.item)
          .then((response) => {
            
            if (this.isSuccessResponse(response)) {
              this.notifySuccess('updateSuccess')
              this.close()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      editItem (item) {
        // this.editedIndex = this.desserts.indexOf(item)
        this.item = item
        this.dialog = true
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.item = this.extend({}, this.defaultItem)
        }, 300)
      }

    },
    mounted () {
    	this.getRoles()
      this.item = this.extend({}, this.defaultItem)
    },

    computed: {

    }

  }
</script>
